import './styles.sass'
import classNames from 'classnames'
import { ReactComponent as LoginBottomImage } from '@/assets/svg/login-bottom.svg'
import { ReactComponent as LoginBottomImageMobile } from '@/assets/svg/login-bottom-mobile.svg'
import { ReactComponent as ListCheck } from '@/assets/svg/list-check.svg'
import { ReactComponent as FirstStepSVG } from '@/assets/svg/first-step.svg'
import { useEffect, useState } from 'react'
import store from '@/core/store'

export function SideSection () {
  const [visible, setVisible] = useState(true)
  useEffect(() => {
    store.on('START_SIDE_MENU:VISIBILITY', (visibility) => {
      setVisible(visibility)
      store.commit('START_SIDE_MENU:VISIBILITY_ACK', visibility)
    })
  }, [])

  function isMobile () {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    return vw < 1040
  }

  const navigateToBottom = () => {
    document.querySelector('.right-side')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  return (<div className={classNames('left-side', {
    'side-menu-ease-out': !visible,
    hidden: window.matchMedia('(max-width: 500px)')?.matches && window?.location?.pathname !== '/auth/signup'
  })}>
    <FirstStepSVG className='step-svg'/>
    <div className="main-text">
      <div className="main-text-container">
        <div className="header-text">
          <p className="main-line">Welcome to boxes</p>
          <p className="second-line">Where you own your communication</p>
        </div>
        <div className="text-list">
          <ul>
            <li><ListCheck className="text-list-icon"/>Own your email</li>
            <li><ListCheck className="text-list-icon"/>Unlimited addresses</li>
            <li><ListCheck className="text-list-icon"/>AI Unsubscribe</li>
            <li><ListCheck className="text-list-icon"/>Take control of your inbox</li>
          </ul>
        </div>
        <div className="navigate-to-sign-up" onClick={navigateToBottom}>
          <div className="arrow bounce"></div>
          <span>Sign up</span>
        </div>
        
      </div>
    </div>
    { isMobile()
      ? <LoginBottomImageMobile className='left-side-footer-img'/>
      : <LoginBottomImage className='left-side-footer-img'/>
    }
  </div>
  )
}
